import React from "react";
import { SadFace } from "@fidget/common/components/icons/sadFace/sadFace";
import { L10n } from "@fidget/common/i18n";
import { BeforeLoginSection } from "../components/beforeLoginSection";

export const ErrorSection: React.SFC<{}> = () => (
  <BeforeLoginSection styleType={"signup"}>
    <header>
      <h2>
        <L10n id={"signup.error"} />
      </h2>
      <SadFace style={{ margin: "auto" }} />
    </header>
    <p>
      <L10n id={"signup.error.description"} />
    </p>
  </BeforeLoginSection>
);
